<!-- 预售专区 -->
<template>
  <cc-container class="detail">
    <!-- 搜索框 -->
    <cc-header-nav title="预售订单详情" @click="gotolist()"></cc-header-nav>
    <!-- 内容部分 -->
    <cc-main>
      <section class="collapse">
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item name="1">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-order"></i>
              <div style="display:flex; justify-content: space-between; width:100%">
                <p class="collapse-title">订单信息</p>
                <p class="collapse-title" style="color:#F53D3D">{{detail.order_state_name}}</p>
              </div>
            </div>
            <p class="collapse-item">订单编号：{{detail.order_number}}</p>
            <p class="collapse-item">下单时间：{{detail.post_date}}</p>
            <p class="collapse-item">订单备注：{{detail.message}}</p>
          </van-collapse-item>
          <van-collapse-item name="2">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-principle"></i>
              <p class="collapse-title">订单原则</p>
            </div>
            <p class="collapse-item">起送金额：满{{detail.send_amount}}元起送</p>
            <p class="collapse-item">结款方式：{{detail.payment_method_name}}</p>
            <p class="collapse-item">验货须知：现场数量清点</p>
            <p class="collapse-item">退货须知：非质量问题不予退货</p>
          </van-collapse-item>
          <van-collapse-item name="3">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-invoice"></i>
              <p class="collapse-title">发票信息</p>
            </div>
            <template v-if="detail.order_invoice">
              <p
                class="collapse-item"
              >发票类型：{{detail.order_invoice.invoice_type==1?'增值税专用发票':'增值税普通发票'}}</p>
              <p class="collapse-item">公司名称：{{detail.order_invoice.invoice_company_name}}</p>
              <p class="collapse-item">纳税人识别号：{{detail.order_invoice.invoice_taxpayer_number}}</p>
              <p class="collapse-item">注册地址：{{detail.order_invoice.invoice_taxpayer_regisaddress}}</p>
              <p class="collapse-item">注册电话：{{detail.order_invoice.invoice_tel}}</p>
              <p class="collapse-item">开户银行：{{detail.order_invoice.invoice_deposit_bank}}</p>
              <p class="collapse-item">银行账号：{{detail.order_invoice.invoice_bank_account}}</p>
            </template>
          </van-collapse-item>
          <van-collapse-item name="4">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-position"></i>
              <p class="collapse-title">配送信息</p>
            </div>
            <p class="collapse-item">联系人：{{detail.contacter}}</p>
            <p class="collapse-item">联系电话：{{detail.contacter_mobile}}</p>
            <p class="collapse-item">收货单位：{{detail.customer_name}}</p>
            <p class="collapse-item">收货地址：{{detail.address}}</p>
          </van-collapse-item>
        </van-collapse>
      </section>
      <cc-card>
        <section class="product-item">
          <div class="product-info">
            <template v-if="detail.order_goods && detail.order_goods.length > 0">
              <div>
                <img class="info-img" v-lazy="detail.order_goods[0].image" />
              </div>
              <div class="info-box">
                <p class="info-title">{{detail.order_goods[0].product_name}}</p>
                <p class="info-desc">规格：{{detail.order_goods[0].norms}}</p>
                <p class="info-desc">厂家：{{detail.order_goods[0].produce_unit}}</p>
                <p class="info-desc">批号：{{detail.order_goods[0].batch_code}}</p>
                <div class="info-price-count-box">
                  <p class="price">￥{{(+detail.order_goods[0].bid_price).toFixed(4)}}</p>
                  <p style="font-size:14px;">购买数量：{{detail.order_goods[0].quantity}}</p>
                </div>
              </div>
            </template>
          </div>
        </section>
      </cc-card>
      <div class="details-deposit">
        <span>
          定金：
          <span class="price">￥{{detail.deposit}}</span>
        </span>
        <span v-if="detail.deposit_payment_date*1>0">已完成</span>
        <span v-else>未完成</span>
      </div>
      <div class="details-deposit" v-if="detail.deposit_payment_type==1">
        <span>
          尾款：
          <span class="price">￥{{detail.last_amout}}</span>
        </span>
        <!-- 要到了尾款支付时间才能显示支付尾款按键，否则只是显示尾款支付时间 -->
        <span
          v-if="detail.order_state==13&&detail.now_time<detail.payment_start_time_stamp*1"
        >{{detail.payment_start_time}}开始支付尾款</span>
        <span v-else-if="detail.final_payment_date*1>0">已完成</span>
        <span v-else>未完成</span>
      </div>
      <div class="details-btn">
        <span
          class="depositBtn btn"
          v-if="detail.can_refund==1"
          @click="applyRefund(detail.order_id)"
        >申请退款</span>
        <span
          class="depositBtn btn"
          v-if="detail.deposit_payment_type==13&&detail.now_time>=detail.payment_start_time_stamp*1&&detail.final_payment_date*1==0"
          @click="payMoney(detail.order_number)"
        >支付尾款</span>
         <span
          class="depositBtn btn"
          v-if="detail.order_state==12"
          @click="payMoney(detail.order_number)"
        >支付定金</span>
         <span
          class="depositBtn btn"
          v-if="detail.order_state==1"
          @click="confirmGoods(detail.order_number)"
        >确认收货</span>
        <span
          class="cancalBtn btn"
          v-if="detail.order_state==12"
          @click="cancalBtn(detail.order_number)"
        >取消订单 </span>
      </div>
    </cc-main>
    <!-- 底部 -->
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>

  </cc-container>
</template>
<script>
import Vue from 'vue'
import { Collapse, CollapseItem, Lazyload, Button, Dialog } from 'vant'
import { ResultCode } from '@/const/ResultCode'
import { presellOrderDetail, chgPresellOrderState, orderOk } from '../../../fetch/pre-sell'
Vue.use(Collapse)
  .use(CollapseItem)
  .use(Lazyload)
  .use(Button)
  .use(Dialog)
export default {
  data () {
    return {
      activeNames: '1',
      detail: {}
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /**
     * @description 加载列表数据
     */
    async loadData () {
      let res = await presellOrderDetail({
        order_number: this.$route.params.id
      })
      if (res.status === ResultCode.SUCCESS) {
        this.detail = res.data.data
        if (this.detail.order_state_name === '尾款待付' || this.detail.order_state_name === '定金待付' || this.detail.order_state_name === '已取消') {
          this.detail.payment_method_name = ''
        }
      }
    },
    /**
     * @description 支付定金
     */
    payMoney (id) {
      window.location = '/order/success/?order_number=' + id
    },
    /**
     * @description 取消定金
     */
    cancalBtn (id) {
      Dialog.confirm({
        message: '您确定要取消定单？'
      }).then(async () => {
        let res = await chgPresellOrderState({
          order_number: id
        })
        if (res.status === 0) {
          this.loadData()
          this.$router.push({ path: '/presell/order' })
        }
      }).catch(() => {
        // on cancel
      })
    },
    /**
     * @description 确认支付
     */
    confirmGoods (id) {
      Dialog.confirm({
        message: '是否确定收货？'
      }).then(async () => {
        let res = await orderOk({
          order_number: id
        })
        if (res.state === 0) {
          this.loadData()
          this.$router.push({ path: '/presell/order' })
        }
      }).catch(() => {
        // on cancel
      })
    },
    /**
     * @description 申请退款
     */
    applyRefund (id) {
      window.location = '/#/order/refund/apply-for-refund?id=' + id
    },

    gotolist () {
      this.$router.push({ path: '/presell/order' })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/var.scss";
@import "~styles/mixins.scss";
.detail {
  .van-collapse-item__content {
    padding: 0;
  }
}
.detail {
  .collapse {
    box-shadow: $box-shadow-base;
    .collapse-title-box {
      @include flex(row);
      align-items: center;
      .collapse-title {
        padding-left: 10px;
      }
    }
    .collapse-item {
      font-size: 12px;
      color: #333;
      margin-left: 40px;
      line-height: 35px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;
      &:last-child {
        border-bottom: 0;
      }
    }
  }
  .checkbox {
    padding-left: 5px;
  }
  .price {
    color: $price-color;
    font-size: 14px;
    line-height: 1;
  }
  .summary-box {
    @include flex(row);
    align-items: center;
    box-shadow: $box-shadow-base;
    background: #fff;
    height: 40px;
    margin-top: 8px;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: space-between;
  }
}
.cc-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
}
.icon-order {
  background: url("~assets/img/sprites/order/order.png");
  background-size: 20px 20px;
}
.icon-principle{
background: url("~assets/img/sprites/order/principle.png");
  background-size: 20px 20px;
}
.icon-invoice{
background: url("~assets/img/sprites/order/invoice.png");
  background-size: 20px 20px;
}
.icon-position {
  background: url("~assets/img/sprites/order/position.png");
  background-size: 20px 20px;
}
.product-item {
  @include flex(row);
  align-items: center;
  margin: 10px 0 0 0;
  padding-top: 10px;
  padding-bottom: 10px;
  .product-info {
    @include flex(row);
    flex: 1;
    padding-right: 10px;
    align-items: center;
    .info-img {
      width: 92px;
      height: 92px;
      box-sizing: border-box;
      border: 1px solid $border-color-base;
      margin-left: 10px;
    }
    .info-box {
      padding-left: 15px;
      flex: 1;
      overflow: hidden;
      .info-title {
        font-size: 14px;
        color: $heading-color;
        margin-bottom: 12px;
        line-height: 1;
      }
      .info-desc {
        color: $text-color-secondary;
        font-size: 12px;
        margin-bottom: 8px;
        line-height: 1;
      }
      .info-price-count-box {
        @include flex(row);
        justify-content: space-between;
      }
    }
  }
  .price {
    color: $price-color;
    font-size: 18px;
    line-height: 1;
    &.promotion {
      color: #777;
    }
  }
  .count {
    color: $heading-color;
    font-size: 12px;
    line-height: 1;
  }
}
.details-deposit {
  padding: 0 10px;
  background: #fff;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #777777;
  line-height: 35px;
  .price {
    color: #f53737;
  }

}
.details-btn {
  height: 45px;
  padding:7px;
  background: #fff;
  box-sizing: border-box;
  border-top: 1px solid #eeeeee;
  width: 100%;
  .depositBtn {
    background: var(--APP_theme_color);
    color: #ffffff;
  }
  .finishBug{
    background: #F7F7F7;
    color: #999999;
    width: 75px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    font-size: 12px;
    border:1px solid #D2D2D2;
    float: right;
    margin-right: 10px;
  }
  .btn{
    height: 28px;
    width: 75px;
    display: block;
    text-align: center;
    line-height: 28px;
    border-radius: 2px;
    margin-right:10px;
    float: right;
  }
  .cancalBtn{
    background: #ffffff;
    color: #777777;
    border:1px solid #E5E5E5;
    float: right;
  }
}
</style>
